import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YouTubePlayerModule } from '@angular/youtube-player';

@Component({
  selector: 'test-vid',
  standalone: true,
  imports: [CommonModule, YouTubePlayerModule],
  templateUrl: './test-vid.component.html',
  styleUrls: ['./test-vid.component.scss']
})
export class TestVidComponent implements OnInit {

  player;

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
      window['onYouTubeIframeAPIReady'] = () => this.onYouTubeIframeAPIReady('Awglf3d9Jf4');
    }, 100);
  }


  onYouTubeIframeAPIReady(id) {
    this.player = new YT.Player('vid-player', {
      width: '100px',
      height: '60px',
      playerVars: { autoplay: 0, rel: 0, controls: 1, modestbranding: 1, iv_load_policy: 3, showinfo: 0, loop: 0 },
      videoId: id,
      events: {
        'onReady': this.onPlayerReady.bind(this),
        'onStateChange': this.onPlayerStateChange.bind(this)
      }
    });
  }

  onPlayerReady() {
    setTimeout(() => {
      this.player.playVideo();
      this.player.mute();
    }, 100);
  }

  onPlayerStateChange(event) {
    // console.log(event);
  }

}
